import React from "react";

import DiscountRule from "components/Tvendo/Article/DataMaster/DiscountRule/List.js";

export default function () {
  return <DiscountRule />;
}
